
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

// Generic interface for all blog post content
export interface BlogPostContentProps {
  content: React.ReactNode;
}

const BlogPostContent: React.FC<BlogPostContentProps> = ({ content }) => {
  return (
    <div className="blog-content">
      {content}
    </div>
  );
};

export default BlogPostContent;
